module.exports = __webpack_public_path__ + "img/3.1d2884ca.jpg";